import Invitation from './components/Invitation';

export default Invitation;
